import { REQUEST_STATUSES } from "@/constants/index.js";

import * as types from "./types.js";
import { ElementService } from "../../../services";

export const getElements = (propertyId, experienceId, query) => {
  return async (dispatch) => {
    dispatch({
      type: types.SET_ELEMENTS_REQUEST_STATUS,
      payload: { propertyId, experienceId, status: REQUEST_STATUSES.LOADING },
    });

    const { resp, status, err } = await ElementService.getElements(propertyId, experienceId, query);

    dispatch({
      type: types.GET_ELEMENTS,
      payload: { propertyId, experienceId, elements: resp?.data || [], status, err },
    });
  };
};

export const refreshElements = (propertyId, experienceId, element) => {
  return async (dispatch) => {
    dispatch({
      type: types.REFRESH_ELEMENTS,
      payload: { propertyId, experienceId, element },
    });
  };
};
